import RiskModal from './RiskModal';
import './RiskModal.scss';

export default RiskModal;
